import ErrorBoundary from '@ms/yammer-libs-error-boundary';
import type { FC } from 'react';
import React from 'react';

import { LoadableDogfoodPerfHUD } from './LoadableDogfoodPerfHUD';

export const DogfoodPerfHUDBoundary: FC = () => (
  <ErrorBoundary name="PerfHUD">
    <LoadableDogfoodPerfHUD />
  </ErrorBoundary>
);
